import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaWaterHeater } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaWaterHeater} />; }
